import { Tabs } from 'antd'
import useFeatureFlags from 'hooks/useFeatureFlags'
import InvoicingRatesSettings from './InvoicingRatesSettings'
import PayRatesSettings from './PayRatesSettings'

const financeSettingsPadding = { padding: '0 24px' as const }

const FinanceSettings = () => {
  const flags = useFeatureFlags({ flagNames: ['invoicing'] })?.data
  const invoicingEnabled = flags?.invoicing?.enabled

  if (!invoicingEnabled) {
    return (
      <div style={financeSettingsPadding}>
        <PayRatesSettings />
      </div>
    )
  }

  const items = [
    {
      key: 'pay-rates',
      label: 'Pay Rates',
      children: <PayRatesSettings />
    },
    {
      key: 'invoicing-rates',
      label: 'Invoicing Rates',
      children: <InvoicingRatesSettings />
    }
  ]

  return (
    <Tabs
      defaultActiveKey="pay-rates"
      style={financeSettingsPadding}
      items={items}
    />
  )
}

export default FinanceSettings
